import React from 'react';
import { useI18n } from '@/contexts/I18nContext';

export interface AchievementData {
  milestone: number;
  title: string;
  description: string;
  emojis: string[];
  numberText: string;
  currentCount?: number;
}

export interface AchievementCardProps {
  achievement?: AchievementData | null;
  isEmpty?: boolean;
  className?: string;
}

const AchievementCard: React.FC<AchievementCardProps> = ({
  achievement,
  isEmpty = false,
  className = ""
}) => {
  const { t } = useI18n();
  
  if (isEmpty || !achievement) {
    return (
      <div className={`flex flex-col items-center justify-center text-center h-full w-full ${className}`}>
        <div className="text-[24px] font-bold text-white mb-2">0</div>
        <div className="text-[10px] text-white leading-tight px-1">Start your journey</div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col h-full w-full justify-between ${className}`}>
      {/* Title with emojis - always show the dynamic title */}
      <div className="flex items-center justify-between mb-2 flex-shrink-0">
        <h3 className="text-[12px] font-bold text-white font-roboto truncate flex-1" title={achievement.title}>
          {achievement.title}
        </h3>
        <div className="flex items-center space-x-1 flex-shrink-0 ml-1">
          {achievement.emojis.map((emoji, index) => (
            <span key={index} className="text-[12px]">{emoji}</span>
          ))}
        </div>
      </div>

      {/* Large number */}
      <div className="text-[28px] font-bold text-white text-center mb-2 flex-shrink-0">
        {achievement.numberText}
      </div>

      {/* Description */}
      <div className="text-[10px] font-light text-gray-400 text-center leading-tight px-1 flex-shrink-0">
        {achievement.currentCount !== undefined && achievement.currentCount > 0
          ? achievement.currentCount === 1
            ? t('home.highlights.one_class_completed')
            : t('home.highlights.classes_completed', { count: achievement.currentCount })
          : t('home.highlights.completed_class')}
      </div>
    </div>
  );
};

export default AchievementCard;
